import { render, staticRenderFns } from "./HeroPageComponent.vue?vue&type=template&id=4e893754&scoped=true&"
import script from "./HeroPageComponent.vue?vue&type=script&lang=ts&"
export * from "./HeroPageComponent.vue?vue&type=script&lang=ts&"
import style0 from "./HeroPageComponent.vue?vue&type=style&index=0&id=4e893754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e893754",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/admin/heropage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e893754')) {
      api.createRecord('4e893754', component.options)
    } else {
      api.reload('4e893754', component.options)
    }
    module.hot.accept("./HeroPageComponent.vue?vue&type=template&id=4e893754&scoped=true&", function () {
      api.rerender('4e893754', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HeroPageComponent.vue"
export default component.exports